import { defineComponent as _defineComponent } from 'vue'
import { useBuilderStore } from '@/store/builder';
import SimpleModal from './SimpleModal.vue';
import { computed, ref } from 'vue';
import { type DataInstance } from '@busy-human/gearbox';
import { Builders } from '@busy-human/hxp-library';
import DotDotDot from './DotDotDot.vue';
import { escape } from 'lodash';
import { useZohoStrings } from '@/store/zohoStrings';

const COUNTDOWN_COOLDOWN = 5;

export default /*#__PURE__*/_defineComponent({
  __name: 'GiveBuilderAccessModal',
  props: {
    builderId: {}
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const props = __props;

const builderStore = useBuilderStore();
const zohoStrings = useZohoStrings();

const selectedBuilder = computed<DataInstance<Builders.Model> | undefined>(() => builderStore.builders[props.builderId]);

const inputEmail = ref("");
// Would be a lot easier to just z.string().trim().safeParse(input.value); but I don't feel like adding zod to the package.json
const emailValid = computed(() => Builders.ModelSchema._def.innerType.shape.email._def.innerType.safeParse(inputEmail.value).success);

const creatingAccount = ref(false);

const error = ref<string | null>(null);

const newAccountPassword = ref<string | null>(null);

const canClickOff = computed(() => {
	if(newAccountPassword.value) return false;
	if(creatingAccount.value) return false;
	return true;
});

const cleanedName = computed(() => escape(`${selectedBuilder.value?.name.firstName}`));
const accessInfoText = computed(() => zohoStrings.getString("zh_giveBuilderAccessInfo").replaceAll("%BUILDERNAME%", cleanedName.value));

const countdownCounter = ref(0);
function countdown(startcount: number) {
	countdownCounter.value = startcount;
	const interval = setInterval(() => {
		countdownCounter.value -= 1;
		if(countdownCounter.value <= 0) {
			clearInterval(interval);
		}
	}, 1000);
}
async function submit() {
	if(!emailValid.value) return;
	creatingAccount.value = true;
	try {
		newAccountPassword.value = await builderStore.createSubUserForBuilder(props.builderId, inputEmail.value);
		countdown(COUNTDOWN_COOLDOWN);
	} catch (e) {
		console.error(e);
		error.value = (e as Error).message;
	} finally {
		creatingAccount.value = false;
	}
}

const __returned__ = { emit, props, builderStore, zohoStrings, selectedBuilder, inputEmail, emailValid, creatingAccount, error, newAccountPassword, canClickOff, cleanedName, accessInfoText, countdownCounter, countdown, COUNTDOWN_COOLDOWN, submit, get useBuilderStore() { return useBuilderStore }, SimpleModal, computed, ref, get Builders() { return Builders }, DotDotDot, get escape() { return escape }, get useZohoStrings() { return useZohoStrings } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})